@if (data$ | async; as item) {
  <div class="searchbox-content-wrapper">
    <div class="searchbox-input-wrapper">
      <div class="searchbox-input">
        <label class="searchbox" [class.dirty]="!!searchInput.value">
          <input
            #searchInput
            [placeholder]="'searchBox.placeholder' | cxTranslate"
            autocomplete="off"
            aria-describedby="initialDescription"
            aria-controls="results"
            [attr.tabindex]="getTabIndex(isMobile | async)"
            [attr.aria-label]="'common.search' | cxTranslate"
            (focus)="open()"
            (click)="search(searchInput.value)"
            (input)="search(searchInput.value)"
            (blur)="close()"
            (keydown.escape)="close()"
            (keydown.enter)="
              close(true);
              launchSearchResult(searchInput.value);
              updateChosenWord(searchInput.value)
            "
            (keydown.arrowup)="focusPreviousChild($any($event))"
            (keydown.arrowdown)="focusNextChild($any($event))"
            value="{{ chosenWord }}" />
          <button [attr.aria-label]="'common.reset' | cxTranslate" (mousedown)="clear(searchInput)"
            (keydown.enter)="clear(searchInput)" class="reset">
            <cx-icon [type]="iconTypes.RESET" class="icon-ICON_Cerrar-Buscador"></cx-icon>
          </button>
          <div role="presentation" class="search-icon">
            <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
          </div>
          <button [attr.aria-label]="'common.search' | cxTranslate" class="search" (click)="open()">
            <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
          </button>
        </label>
      </div>
      <div class="searchbox-action">
        <cx-icon [type]="iconTypes.CLOSE" aria-label="close" class="reset" tabindex="0"
          (click)="close(true)"
          (keydown)="close(true)"
          (keyup)="close(true)"
        ></cx-icon>
      </div>
    </div>
    @if (results$ | async; as result) {
      <div class="results" id="results">
        @if (result.message) {
          <div class="message" [innerHTML]="result.message"></div>
        }
        @if (result.suggestions?.length || result.products?.length) {
          <div class="product-results-suggestions">
            @if (result.suggestions.length) {
              <div class="suggestions-wrapper">
                <div class="suggestions-content">
                  <div class="suggestion-title">
                    {{'searchBox.suggestions' | cxTranslate}}
                  </div>
                  <ul
                    tabindex="0"
                    attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}"
                    role="listbox"
                    class="suggestions">
                    @for (suggestion of  result.suggestions; track suggestion) {
                      <li role="option" >
                        <a
                          [innerHTML]="suggestion | cxHighlight: searchInput.value"
                  [routerLink]="
                    {
                      cxRoute: 'search',
                      params: { query: suggestion }
                    } | cxUrl
                  " 
                          (keydown.arrowup)="focusPreviousChild($event)"
                          (keydown.arrowdown)="focusNextChild($event)"
                          (keydown.enter)="close(true)"
                          (keydown.escape)="close(true)"
                          (blur)="close()"
                          (mousedown)="preventDefault($event)"
                  (click)="
                    dispatchSuggestionEvent({
                      freeText: searchInput.value,
                      selectedSuggestion: suggestion,
                      searchSuggestions: result.suggestions
                    });
                    updateChosenWord(suggestion)
                  "
                          >
                        </a>
                      </li>
                    }
                  </ul>
                </div>
                <app-custom-link-list [item]="item.helpLinkComponent" class="hidden-mobile"></app-custom-link-list>
              </div>
            }
            @if (result.products?.length) {
              <div class="products-content">
                <div class="product-title">
                  <div class="product-title-text">{{ 'searchBox.products' | cxTranslate }}</div>
                  <div class="actions">
                    <a class="button-search" [routerLink]="{ cxRoute: 'search', params: { query: searchInput.value }} | cxUrl"
                      (mousedown)="preventDefault($event)"><span>{{'searchBox.actions.seeAll' | cxTranslate}}</span></a>
                    </div>
                  </div>
                  @if (result.products) {
                    <ul
                      attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}"
                      role="listbox"
                      class="products">
                      @for (product of result.products; track product) {
                        <li role="option">
                          <a
                            role="option"
                [routerLink]="
                  {
                    cxRoute: 'product',
                    params: product
                  } | cxUrl
                 " 
                            [class.has-media]="config.displayProductImages"
                            (keydown.arrowup)="focusPreviousChild($event)"
                            (keydown.arrowdown)="focusNextChild($event)"
                            (keydown.enter)="close(true)"
                            (keydown.escape)="close(true)"
                            (blur)="close()"
                            (mousedown)="preventDefault($event)"
                (click)="
                  dispatchProductEvent({
                    freeText: searchInput.value,
                    productCode: product.code
                  })
                ">
                            @if (config.displayProductImages) {
                              <cx-media
                                [container]="product.images?.PRIMARY"
                                format="thumbnail"
                              role="presentation"></cx-media>
                            }
                            <div class="name" [innerHTML]="product.nameHtml"></div>
                            <!-- <span class="price">{{ product.price?.formattedValue }}</span> -->
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
              <div class="visible-mobile">
                <app-custom-link-list [item]="item.helpLinkComponent"></app-custom-link-list>
              </div>
            </div>
          }
          <span id="initialDescription" class="cx-visually-hidden">
            {{ 'searchBox.initialDescription' | cxTranslate }}
          </span>
          @if (result.suggestions?.length || result.products?.length) {
            <div aria-live="assertive"
              class="cx-visually-hidden">
              {{ 'searchBox.suggestionsResult' | cxTranslate: { count: result.suggestions?.length } }}
              {{ 'searchBox.productsResult' | cxTranslate: { count: result.products?.length } }}
              {{ 'searchBox.initialDescription' | cxTranslate }}
            </div>
          }
          @if (!result.suggestions.length) {
            <section class="static-content">
              <div>
                <app-custom-link-list [item]="item.mostWantedLinkComponent"></app-custom-link-list>
              </div>
              <div>
                <app-custom-simple-product-list [item]="item.productTrendingComponent"></app-custom-simple-product-list>
              </div>
            </section>
          }
        </div>
      }
    </div>
  }
